import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "content flex-row-fluid" }
const _hoisted_2 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Danh sách hồ sơ đã xóa", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-400 border-start mx-4" }, null, -1)
const _hoisted_5 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1" }
const _hoisted_6 = { class: "breadcrumb-item text-muted" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/dashboard",
  class: "text-muted text-hover-primary"
}, "Dashboard", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card-header border-0 pt-6 umt-form" }
const _hoisted_12 = { class: "card-title" }
const _hoisted_13 = {
  key: 0,
  class: "d-flex align-items-center gap-2 my-1 umt-form"
}
const _hoisted_14 = { class: "d-flex align-items-center position-relative" }
const _hoisted_15 = { class: "svg-icon svg-icon-3 position-absolute ms-4" }
const _hoisted_16 = {
  key: 1,
  class: "badge badge-light-primary fs-8 py-2 px-3 d-flex align-items-center text-nowrap",
  style: {"height":"32px"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-square me-1" }, null, -1)
const _hoisted_18 = { class: "card-toolbar gap-2" }
const _hoisted_19 = ["title"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-counterclockwise me-1" }, null, -1)
const _hoisted_21 = { class: "card-body pt-0 umt-table umt-table-compact" }
const _hoisted_22 = { class: "d-flex align-items-center bg-light-warning rounded px-3 py-2 mb-3 fs-8 text-gray-700" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle-fill text-warning me-2 fs-6" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-danger fs-9 mx-1" }, "Ứng viên đã xóa", -1)
const _hoisted_25 = {
  key: 0,
  class: "form-check form-check-sm form-check-custom form-check-solid disabled"
}
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 1,
  class: "form-check form-check-sm form-check-custom form-check-solid"
}
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "menu-link text-gray-600" }
const _hoisted_30 = { class: "menu-link fw-semibold text-gray-700" }
const _hoisted_31 = { class: "menu-link text-nowrap fw-semibold text-gray-800" }
const _hoisted_32 = {
  key: 0,
  class: "text-muted fs-8 fw-normal"
}
const _hoisted_33 = { class: "menu-link text-gray-600" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = { class: "menu-link text-gray-600" }
const _hoisted_36 = ["title"]
const _hoisted_37 = {
  key: 0,
  class: "badge badge-light-danger fs-8",
  title: "Ứng viên của hồ sơ này cũng đã bị xóa — khôi phục ứng viên trước"
}
const _hoisted_38 = {
  key: 1,
  class: "menu-link text-gray-600"
}
const _hoisted_39 = { class: "d-flex flex-center gap-5" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lock text-gray-500" }, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-counterclockwise fs-5" }, null, -1)
const _hoisted_45 = [
  _hoisted_44
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_permission = _resolveDirective("permission")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8)), [
          [_directive_permission, [_ctx.Permission.DASHBOARD_VIEW,_ctx.Permission.DASHBOARD]]
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-light ms-auto umt-btn-32",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
      }, [
        _hoisted_9,
        _createTextVNode("Quay lại ")
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_ctx.checkedCustomers.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                    class: "form-control w-250px ps-11",
                    style: {"height":"32px","min-height":"32px","padding-top":"0","padding-bottom":"0","font-size":"13px"},
                    placeholder: "Tìm tên, mã hồ sơ..."
                  }, null, 512), [
                    [_vModelText, _ctx.search]
                  ])
                ]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.filterDeletedBy,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterDeletedBy) = $event)),
                  filterable: true,
                  placeholder: "— Người xóa —",
                  "popper-class": "umt-form-dd",
                  class: "form-select-solid w-175px",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchItems()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "— Người xóa —",
                      value: ""
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deletedByOptions, (u) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: u,
                        label: u,
                        value: u
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                _hoisted_17,
                _createTextVNode("Đã chọn " + _toDisplayString(_ctx.checkedCustomers.length) + " ", 1),
                _createElementVNode("i", {
                  class: "bi bi-x-lg ms-2 cursor-pointer",
                  title: "Bỏ chọn tất cả",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.checkedCustomers = []; _ctx.checkDefault = false})
                })
              ]))
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_ctx.checkedCustomers.length !== 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-sm btn-primary umt-btn-32 text-nowrap",
                title: `Khôi phục ${_ctx.checkedCustomers.length} hồ sơ đã chọn`,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.restoreMutilAdmission()))
              }, [
                _hoisted_20,
                _createTextVNode("Khôi phục (" + _toDisplayString(_ctx.checkedCustomers.length) + ") ", 1)
              ], 8, _hoisted_19))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("span", null, [
            _createTextVNode(" Hồ sơ có nhãn "),
            _hoisted_24,
            _createTextVNode(" (dòng nền xám) không khôi phục trực tiếp được — vào "),
            _createVNode(_component_router_link, {
              to: "/danhsachungviendaxoa",
              class: "fw-bold text-primary mx-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Danh sách ứng viên đã xóa")
              ]),
              _: 1
            }),
            _createTextVNode(" khôi phục ứng viên trước, hồ sơ sẽ khôi phục theo. ")
          ])
        ]),
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableData,
          total: _ctx.tableData.length,
          currentPage: _ctx.pagination.currentPage,
          "table-header": _ctx.tableHeader,
          "rows-per-page": _ctx.pagination.limit,
          "enable-items-per-page-dropdown": true,
          loading: _ctx.loading,
          onCurrentCheckAll: _ctx.checkAll,
          isCheck: _ctx.checkDefault,
          classTable: "hs-del-list"
        }, {
          "cell-checkbox": _withCtx(({ row: customer }) => [
            (customer.isDeleteOfStudent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    value: customer.id
                  }, null, 8, _hoisted_26)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input form-auto-check",
                    type: "checkbox",
                    value: customer.id,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkedCustomers) = $event))
                  }, null, 8, _hoisted_28), [
                    [_vModelCheckbox, _ctx.checkedCustomers]
                  ])
                ]))
          ]),
          "cell-method": _withCtx(({ row: customer }) => [
            _createElementVNode("div", _hoisted_29, _toDisplayString(customer.method), 1)
          ]),
          "cell-profileCode": _withCtx(({ row: customer }) => [
            _createElementVNode("div", _hoisted_30, _toDisplayString(customer.profileCode), 1)
          ]),
          "cell-fullName": _withCtx(({ row: customer }) => [
            _createElementVNode("div", _hoisted_31, [
              _createTextVNode(_toDisplayString(customer.fullName) + " ", 1),
              (customer.idCard)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, "CCCD: " + _toDisplayString(customer.idCard), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          "cell-majors": _withCtx(({ row: customer }) => [
            _createElementVNode("div", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.majors, (item, index) => {
                return (_openBlock(), _createElementBlock("span", { key: index }, [
                  _createTextVNode(_toDisplayString('- '+item.name), 1),
                  _hoisted_34
                ]))
              }), 128))
            ])
          ]),
          "cell-date": _withCtx(({ row: customer }) => [
            _createElementVNode("div", _hoisted_35, _toDisplayString(customer.date), 1)
          ]),
          "cell-deletedBy": _withCtx(({ row: customer }) => [
            _createElementVNode("div", {
              class: "menu-link text-gray-600 text-truncate",
              style: {"max-width":"160px"},
              title: customer.deletedBy
            }, _toDisplayString(customer.deletedBy), 9, _hoisted_36)
          ]),
          "cell-reason": _withCtx(({ row: customer }) => [
            (customer.isDeleteOfStudent)
              ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Ứng viên đã xóa"))
              : (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(customer.reason), 1))
          ]),
          "cell-actions": _withCtx(({ row: customer }) => [
            _createElementVNode("div", _hoisted_39, [
              (customer.isDeleteOfStudent)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.restoreAdmission(customer)),
                    class: "btn btn-sm btn-icon btn-light",
                    title: "Khôi phục ứng viên trước khi khôi phục hồ sơ này"
                  }, _hoisted_42, 8, _hoisted_40))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    onClick: ($event: any) => (_ctx.restoreAdmission(customer)),
                    class: "btn btn-sm btn-icon btn-light-primary",
                    title: "Khôi phục hồ sơ"
                  }, _hoisted_45, 8, _hoisted_43))
            ])
          ]),
          _: 1
        }, 8, ["table-data", "total", "currentPage", "table-header", "rows-per-page", "loading", "onCurrentCheckAll", "isCheck"])
      ])
    ])
  ])), [
    [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_VIEW_DELETE,_ctx.Permission.ADMISSION_REGISTER]]
  ])
}